/* eslint-disable react/prefer-es6-class */
/* eslint-disable no-unused-vars */
import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import _ from 'underscore';

import WorkspaceActions from '../../../common/flux/WorkspaceActions.js';
import ChildCategory from './ChildCategory';
import EditCategoryModal from './modals/EditCategoryModal';
import DeleteCategoryModal from './modals/DeleteCategoryModal';
import RestrictedComponent, { hasPermission } from '../../../lib/components/form/RestrictedComponent.js';
import schema from '../../../routes/permissions/schema.js';

var Category = createReactClass({

    getInitialState: function () {
        return {
            deleteModal: false,
            editModal: false,
            validators: [],
            edited: false,
            edits: {}
        };
    },

    selectedCategory: function () {
        if (this.props.mode == 'select-one' || this.props.mode == 'select-multiple') {
            WorkspaceActions.resolveIntent(this.props.category, 'select-category');
        } else if (this.props.mode == 'select') {
            // console.log(this.props);
            this.props.actions.selectedMetadataItem.bind(null, this.props.category).call();
        } else if (this.props.mode == 'event') {
            this.props.assignCategoryToEvent.bind(null, this.props.category.categoryID).call();
        }
    },

    toggleDeleteModal: function () {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    toggleEditModal: function () {
        this.setState({
            editModal: !this.state.editModal
        });
    },

    render: function () {
        var { assigned, category, mode, actions, categories, nested } = this.props;

        var footer;
        var renderedChildren = [];
        if (this.props.nested && this.props.term === '') {
            var children = _.toArray(this.props.nested);
            for (var j = 0; j < children.length; j++) {
                var child = children[j];

                var properties = {
                    mode: mode,
                    actions: actions,
                    categories: categories,
                    assigned: assigned,
                    nested: nested
                };

                if (mode == 'event') {
                    properties.assignCategoryToEvent = this.props.assignCategoryToEvent;
                }

                renderedChildren.push(
                    <ChildCategory
                        assignedCategories={this.props.assignedCategories}
                        isAssignedGroup={this.props.isAssignedGroup}
                        {...properties}
                        key={'child-category-' + child.categoryID}
                        child={child}
                    />
                );
            }
        }

        if (renderedChildren.length) {
            footer = (<div className="panel-footer">
                <label>Child Categories:</label>
                <div className="child-category-listing">{renderedChildren}</div>
            </div>);
        }

        return (
            <div className="panel panel-default category">
                <div className="panel-body">
                    <div className="col-sm-9 name">
                        <h5>{this.props.category.categoryName}</h5>
                        <p><i>Display Name:</i> {this.props.category.displayName || ''}</p>
                        <p><i>Description:</i> {this.props.category.categoryDescription || ''}</p>
                    </div>
                    <div className="col-sm-3 actions">
                        {this.renderAction()}
                    </div>
                </div>
                {footer}

                {this.renderModals()}
            </div>
        );
    },

    renderAction: function () {
        const inAssignedGroup = !this.props.isAssignedGroup || 
            (this.props.isAssignedGroup && 
                this.props.assignedCategories.some(category => category.categoryID === this.props.category.categoryID)
            )
        const groupPermissionLabel = !inAssignedGroup ? 'You do not have this category assigned to your content groups' : undefined
        switch (this.props.mode) {
            case 'select-one':
            case 'select':
            case 'event':
                return (<button type="button"
                    className="btn btn-default"
                    onClick={this.selectedCategory}>
                    <i className="fa fa-check"/> Assign
                </button>);

            case 'manage':
                return (
                    <div className="btn-group">
                        <RestrictedComponent
                            label={groupPermissionLabel}
                            permissionCheck={hasPermission(schema.MANAGE_CLIENT_CATEGORIES.UPDATE) && inAssignedGroup}
                        >
                            <button
                                type="button"
                                className="btn btn-default"
                                onClick={this.toggleEditModal}
                            >
                                <i className="fa fa-pencil"/> Edit
                            </button>
                        </RestrictedComponent>
                        <RestrictedComponent
                            label={groupPermissionLabel}
                            permissionCheck={hasPermission(schema.MANAGE_CLIENT_CATEGORIES.DELETE) && inAssignedGroup}
                        >
                            <button
                                type="button"
                                className="btn btn-default"
                                onClick={this.toggleDeleteModal}
                            >
                                <i className="fa fa-trash-can"/> Delete
                            </button>
                        </RestrictedComponent>
                    </div>
                );
        }
    },

    renderModals: function () {
        var sharedProps = {
            actions: this.props.actions,
            category: this.props.category,
            categories: this.props.categories,
            nested: this.props.nested,
            isParent: this.props.isParent
        };

        if (this.state.editModal) {
            return <EditCategoryModal
                {...sharedProps}
                toggle={this.toggleEditModal}
            />;
        } else if (this.state.deleteModal) {
            return <DeleteCategoryModal
                {...sharedProps}
                toggle={this.toggleDeleteModal}
            />;
        }
    }
});

export default Category;
